<script setup lang="ts">
interface Props {
    class?: string
    disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    class: '',
    disabled: false
})

const emit = defineEmits<{ click: [] }>()
</script>

<template>
    <v-tooltip
        location="start"
        content-class="bg-black border-sm text-tooltip"
        max-width="200"
    >
        <template #activator="{ props: bind }">
            <v-icon-btn
                v-bind="bind"
                icon="mdi-close"
                size="small"
                color="transparent"
                rounded="lg"
                :class="props.class"
                :disabled="props.disabled"
                @click="emit('click')"
            />
        </template>
        Remove
    </v-tooltip>
</template>

<style scoped>

</style>
